import React from 'react';

function SavingOverlay({ message }) {
  if (!message) return null;

  return (
    <div className="saving-overlay">
      <div className="saving-content">
        <div className="saving-spinner"></div>
        <p>{message}</p>
      </div>
    </div>
  );
}

export default SavingOverlay;